import React from 'react';
import { Switch, Route } from 'react-router-dom'

import Routes from '../../routes';

const Main = () =>  {
    return (
        <div id="page-wrapper">
            <Switch>
                {
                    Routes.reduce((arr, route) => {
                        if(route.type === 'folder') {
                            route.routes.forEach(subRoute => arr.push(<Route exact path={subRoute.path} component={subRoute.component} key={subRoute.path}/>));
                        }
                        else arr.push(<Route exact path={route.path} component={route.component} key={route.path}/>);

                        return arr;
                    }, [])
                }
            </Switch>
        </div>
    );
};

export default Main;








// WEBPACK FOOTER //
// ./src/components/Main/index.js